import axios from '@/axios/'

const actions = {
  getLotteryPurchaseHistory(_, param) {
    return axios.post('/GetLotteryPurchaseHistory/1.0/', param)
  },
  getLotteryPurchaseHistoryDetail(_, param) {
    return axios.post('/GetLotteryPurchaseHistoryDetail/1.0/', param)
  },
  setLotteryCancel(_, param) {
    return axios.post('/SetLotteryCancel/1.0/', param)
  },
  getlotteryCancelCompleteInfo(_, param) {
    return axios.post('/GetLotteryCancelCompleteInfo/1.0/', param)
  },
}

const state = {
  pageNum: undefined
}

const mutations = {
  // ページ番号 設定
  setPageNum(state, pageNum){
    state.pageNum = pageNum
  },
  // ページ番号 削除
  clearPageNum(state){
    state.pageNum = undefined
  },
}

export default {
  namespaced: true,
  actions,
  state,
  mutations,
}